import React from "react";
import { useWatch } from "react-hook-form";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";
import { gruposDespesa, calcularTotalGrupo } from "views/ManutencaoDRE/gruposDespesa";
import CampoAjuda from "components/Inputs/CampoAjuda";

function formatarValor(numero) {
    return numero.toFixed(2).replace(".", ",");
}

// [DTS-7123] Consolida os 7 subtotais de grupo (DTS-7122) + Total Funcionários +
// Despesas Totais. useWatch cobre os campos dos 7 grupos, isolado dos ~103 inputs
// não controlados da tela -- digitar em qualquer grupo recalcula só este bloco.
export default function TotalDespesas({ control, indicador }) {
    const todosOsNomes = gruposDespesa.flatMap(grupo => grupo.campos.map(campo => campo.name));
    const observados = useWatch({ control, name: todosOsNomes }) || {};

    const totalPorGrupo = {};
    gruposDespesa.forEach(grupo => {
        totalPorGrupo[grupo.key] = calcularTotalGrupo(grupo, observados, indicador);
    });

    const totalFuncionarios = totalPorGrupo.vendedores + totalPorGrupo.gerentes + totalPorGrupo.caixa + totalPorGrupo.administrativo;
    const despesasTotais = totalFuncionarios + totalPorGrupo.ocupacao + totalPorGrupo.estrutural + totalPorGrupo.cartao;

    const campo = (label, valor, ajuda) => (
        <Col lg="3" md="6" sm="12">
            <FormGroup>
                <Label>{label} (R$) {ajuda && <CampoAjuda texto={ajuda} />}</Label>
                <Input className="form-control text-md-right" disabled readOnly value={formatarValor(valor)} />
            </FormGroup>
        </Col>
    );

    const ajudaOcupacao = gruposDespesa.find(g => g.key === "ocupacao").ajuda;

    return (
        <>
            <Row className="align-items-end">
                {campo("Total Vendedores", totalPorGrupo.vendedores)}
                {campo("Total Gerentes", totalPorGrupo.gerentes)}
                {campo("Total Caixa", totalPorGrupo.caixa)}
                {campo("Total Administrativo", totalPorGrupo.administrativo)}
            </Row>
            <Row className="align-items-end">
                {campo("Total Funcionários", totalFuncionarios)}
                {campo("Total Ocupação", totalPorGrupo.ocupacao, ajudaOcupacao)}
                {campo("Total Estrutural", totalPorGrupo.estrutural)}
                {campo("Total Cartão", totalPorGrupo.cartao)}
            </Row>
            <Row>
                <Col lg="12">
                    <FormGroup className="subtotalGrupo">
                        <div className="subtotalGrupoBarra">
                            <span>Despesas Totais (R$)</span>
                            <span>{formatarValor(despesasTotais)}</span>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}
